import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch, Route, useRouteMatch } from "react-router-dom";
export const SubRouter = ({ route: { mainComponent: MainComponent, subRoutes = [] }, }) => {
    const { path } = useRouteMatch();
    return (_jsxs(Switch, { children: [_jsx(Route, Object.assign({ exact: true, path: path }, { children: _jsx(MainComponent, {}, void 0) }), void 0),
            subRoutes.map(({ component: Component, path: subPath }, key) => (_jsx(Route, Object.assign({ path: `${path}${subPath}` }, { children: _jsx(Component, {}, void 0) }), key)))] }, void 0));
};
//# sourceMappingURL=SubRouter.js.map